export const ApplicationConstant = {
  HOME_PAGE_PATH: "/",

  HOME_PAGE_WEB_DEVELOPMENT_PATH: "/web-development",
  WEB_LEARNING : "/web-development/learn",
  WEB_VIEW_INTERNSHIPS:'/web-development/internships',

  HOME_PAGE_MACHINE_LEARNING_PATH: "/machine-learning",
  
  ALLINTERNSHIP_PAGE_PATH: "/all-internship-list",
  LOGIN_URL_PATH: "/login",
  ALL_CERTIFICATIONS: "/all-certifications-list",
  FORGOTPASSWORD_URL_PATH: "",

  FORGOTPASSWORD_DYNAMIC_URL_PATH: "/:passwordfunction",
  
  MYACCOUNT_URL: "/account",
  MYACCOUNT_PROFILE_URL: "/account/profile",
  MYACCOUNT_PROFILE_DYNAMIC_URL: "/account/profile/:id",
  MYACCOUNT_MYINTERSHIPS_URL: "/account/internships",
  MYACCOUNT_MYINTERSHIPS_DYNAMIC_URL: "/account/internships/:id",
  MYACCOUNT_MYCERTIFICATES_URL: "/account/certificates",
  MYACCOUNT_MYCERTIFICATES_DYNAMIC_URL: "/account/certificates/:id",
  MYACCOUNT_ADD_NEW_INTERNSHIP_URL: "/account/add-new-internship",
  MYACCOUNT_ADD_NEW_INTERNSHIP_DYNAMIC_URL: "/account/add-new-internship/:id",
  MYACCOUNT_ADD_NEW_CERTIFICATIONS_URL: "/account/add-new-certifications",
  MYACCOUNT_ADD_NEW_CERTIFICATIONS_DYNAMIC_URL:
    "/account/add-new-certifications/:id",
  MYACCOUNT_EDIT_URL: "/account/edit-profile",
  MYACCOUNT_EDIT_DYNAMIC_URL: "/account/edit-profile/:id",
};
